<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0" v-if="$route.name === names.SCIENCE_ID.BIND">
    <div class="page__title">
      Уважаемый пользователь!<br>
      Было обнаружено, что пользователь с указанным адресом электронной почты уже зарегистрирован в проекте «Менделеевская карта».<br>
      Предлагаем вам объединить вашу учетную запись Science-ID с учетной записью проекта «Менделеевская карта».<br>
      <p class="mt-8">Для этого введите ваш пароль от аккаунта проекта «Менделеевская карта»</p>
    </div>
    <div v-if="!loading">
      <div class="text_field__container" v-if="error">
        <div class="text__field">
          <v-alert
              class="error_alert"
              :value="true"
              outline
              :icon="false"
              color="#8f0808"
              variant="outlined"
          >
            <span v-if="error.error">
              {{ error.error }}
            </span>
            <span v-else>
              При попытке связывания аккаунтов произошла ошибка
            </span>
          </v-alert>
        </div>
      </div>
      <v-form
          ref="form"
          class="text_field__container"
      >
        <v-text-field
            id="password"
            v-model="data.password"
            :append-inner-icon="show ? 'visibility_off' : 'visibility'"
            :type="show ? 'text' : 'password'"
            :rules="[rules.required, rules.symbControl]"
            :loading="loading"
            @click:appendInner="show = !show"
            @keyup.enter="validate"
            class="text__field"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            :error="hasError('password')"
            :error-messages="getError('password')"
        >
          <template v-slot:label>
            <div class="label__text">
              Пароль
            </div>
          </template>
        </v-text-field>
      </v-form>
      <div v-if="error" class="btn__next" @click="$router.push({name: names.MAIN})">
          <span class="btn__next_text">
            На главную
          </span>
      </div>
      <v-btn
          v-else
          class="btn__next"
          elevation="0"
          :loading="loading"
          @click="validate"
      >
          <span class="btn__next_text">
            Отправить
          </span>
      </v-btn>
    </div>
    <div v-else>
      <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
        <fulfilling-square-spinner
            :animation-duration="4000"
            :size="100"
            color="#34347C"
        />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import { set_stores } from "@/store/modules/auth"
import { FulfillingSquareSpinner } from "epic-spinners"

export default defineComponent({
  name: "BindAccounts",
  mixins: [FormErrorsMixin],
  components: { FulfillingSquareSpinner },
  data () {
    return {
      loading: false,
      error: null,
      valid: false,
      show: false,
      error_reg: false,
      data: {
        token: undefined,
        password: null,
        type: "Oauth",
      },
      rules: {
        required: value => !!value || 'Введите пароль',
        symbControl: value => this.symbControl(value) || 'Некорректный ввод',
      }
    }
  },
  watch: {
    data: {
      handler: function () {
        this.errors = {
          fields: {},
          non: []
        }
        this.error = null
      },
      deep: true
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  methods: {
    set_stores: set_stores,
    ...mapActions({
      linkingScienceId: 'personal_account/science_id/linkingScienceId',
    }),
    endRedirect () {
      this.$router.push({ name: pa_names.MAIN })
    },
    async validate () {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        this.bindScienceId()
      }
    },
    bindScienceId () {
      this.loading = true
      this.error = null
      this.linkingScienceId(
        {
          data: this.data,
          finalizer: (data) => {
            this.loading = false
            this.error = null
            this.set_stores(data.token, data.email, "")
            setTimeout(() => {
              this.endRedirect()
            }, 300)
          },
          catcher: (error) => {
            this.loading = false
            if (error.error) {
              this.error = error
            } else {
              this.mapErrors(error)
            }
          }
        }
      )
    },
    symbControl: function (value) {
      if (value === null) {
        return true
      }
      return !(value.includes(' ') || value.includes('\n'))
    }
  },
  created () {
    if (this.$route.query.token && !this.isAuthenticated) {
      this.data.token = this.$route.query.token
      this.data.type = this.$route.query.type
    } else {
      this.$router.push({ name: names.MAIN })
    }
  },
})
</script>

<style scoped lang="scss">
.page__title {
  padding: 0 80px;
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 42px;
  line-height: 56px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.page__text {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  line-height: normal;
  text-align: center;

  color: #858484;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 700px;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 220px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 36px;
    line-height: 48px;
    padding: 0 60px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 30px;
    line-height: 36px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }

  .text_field__container {
    width: 500px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 24px;
    line-height: 28px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    margin: 0 10px 20px;
    height: 55px;

    &.back {
      margin-right: 10px;
    }
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }
}
</style>
